var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpravljanjeMerama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_901_1489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 9C11 7.896 10.104 7 9 7C7.896 7 7 7.896 7 9C7 10.104 7.896 11 9 11C10.104 11 11 10.104 11 9ZM11 9H25M18 16C18 14.896 17.104 14 16 14C14.896 14 14 14.896 14 16C14 17.104 14.896 18 16 18C17.104 18 18 17.104 18 16ZM18 16H25M10 16H7M17 23H7M31 30C31 30.553 30.553 31 30 31H2C1.447 31 1 30.553 1 30V2C1 1.447 1.447 1 2 1H30C30.553 1 31 1.447 31 2V30ZM25 23C25 21.896 24.104 21 23 21C21.896 21 21 21.896 21 23C21 24.104 21.896 25 23 25C24.104 25 25 24.104 25 23Z",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_901_1489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpravljanjeMerama);
export default __webpack_public_path__ + "static/media/UpravljanjeMerama.ef651686cb4957188c46421b136cec48.svg";
export { ForwardRef as ReactComponent };